module.exports = __webpack_public_path__ + "media/images/talent/flow-04-3548520eab8cf7cbd4c5a4841ff33773.png";